import { formatDataCell } from '@/finsight/ui/components/deals/helpers';

const CommonCell = ({ row, cellName }) => formatDataCell(row[cellName]);

export default CommonCell;
